import { Addition } from "@/pages/heat-report/models/HeatReportModels";
import { getMomentTz } from "@dexteel/mesf-core";
import { ColDef, ColGroupDef } from "ag-grid-enterprise";
const moment = getMomentTz();

export const useTableData = () => {
	const getAdditionType = (typeCode: string) => {
		switch (typeCode) {
			case "E":
				return "EAF";
			case "L":
				return "Ladle";
			case "T":
				return "Trim";
			case "F":
				return "Flux";
			case "W":
				return "Wire";
			default:
				return typeCode;
		}
	};

	const columns: ColGroupDef[] = [
		{
			headerName: "Additions",
			children: [
				{
					field: "Timestamp",
					headerName: "Time",
					flex: 1,
					minWidth: 55,
					cellStyle: {
						textAlign: "center",
					},
					valueGetter: (params: any) => {
						if (params.data.Timestamp) {
							return moment((params.data as Addition).Timestamp).format(
								"HH:mm",
							);
						}
					},
				},
				{
					field: "MaterialName",
					headerName: "Material",
					flex: 1,
					minWidth: 64,
				},
				{
					field: "Quantity",
					headerName: "Weight [kg]",
					flex: 1,
					minWidth: 102,
					cellStyle: {
						textAlign: "center",
					},
					valueGetter: (params: any) => {
						if (params.data.Quantity) {
							return Math.floor((params.data as Addition).Quantity);
						}
					},
				},
				{
					field: "AdditionTypeCode",
					headerName: "Type",
					flex: 1,
					minWidth: 64,
					cellStyle: {
						textAlign: "center",
					},
					valueGetter: (params: any) => {
						if (params.data.AdditionTypeCode) {
							return getAdditionType(params.data.AdditionTypeCode);
						}
					},
				},
			],
		},
	];

	const defaultColDef: ColDef = {
		filter: false,
		floatingFilter: false,
		sortable: false,
		resizable: false,
		editable: false,
		suppressHeaderMenuButton: true,
	};

	return { columns, defaultColDef };
};
